import React from "react";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import ScrollTop from "../ScrollTop.js";
import SideBox from "../SideBox.js";
import Content from "../../components/ContentHeader.js";
import Route from "../../components/Route.js";

// css
import "../../css/News.css";
import "../../css/NewsPage.css";
import "../../css/Conference.css";

// img
import Cont06 from "../../assets/img/web_cont06.png";

function contents06() {
  return (
    <div className="webinar_wrap">
      <ScrollTop />

      <SideBox />

      {/* 페이지 타이틀명 설정 */}
      <Helmet>
        <title>레인보우브레인 | RPA+생성형AI 자동화 서비스 전문기업</title>
      </Helmet>
      <Content
        title="CONFERENCE"
        title1="콘텐츠를 통해 인사이트를 얻어보세요"
      />

      <Route route1="MEDIA" route2="CONFERENCE"></Route>

      <div className="contents_wrap content_bg">
        <div className="container">
          <div className="news_box">
            <div className="news_badge">
              <span>ONLINE</span>
            </div>

            <div className="news_content">
              <img src={Cont06} alt="이미지" />

              <div className="text_box">
                <p>
                  빅데이터가 유행할 때는 어떻게든 데이터를 모아 놓은 다음에
                  나중에 예측과 통찰을 얻기 위해 이를 활용할 수 있다는 희망이
                  있었다. 이제 오픈소스 LLM 모델을 레버리지로 삼아 비즈니스
                  운영에 필요한 의사 결정까지도 가능한 수준에 도달할 것으로
                  보인다.
                  <br />
                  기존 RPA가 정형화되고 반복적인 작업을 중심으로 생산성은
                  높였다면, 이제 LLM이 데이터 중심의 프로세스를 정립하는
                  과정에서 큰 몫을 담당할 것으로 보인다.
                </p>
              </div>
            </div>

            <div className="btn_webinar">공개예정</div>

            <div className="news_btn">
              <Link to="/media/Conference">
                <button className="btn_prev">목록</button>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default contents06;
